import { useState } from "react";
import "./styles.css";
import dropDown from "../../assets/drop-down.svg";
import { useTranslationSetup } from "../../utils/useTranslationSetup";
import { Divider, Box } from "@mui/material";

const DetailedResultCard = ({
  heading,
  subHeading,
  bgColor,
  icon,
  innerBorderColor,
  words,
}) => {
  const { t } = useTranslationSetup();
  const [open, setOpen] = useState(false);

  const dropdown = () => {
    setOpen(!open);
  };

  return (
    <Box
      className="detailed-result-item-wrapper"
      style={{ backgroundColor: `${bgColor}` }}
      onClick={dropdown}
    >
      {heading === "Incorrect words" ? (
        <Box className="detailed-result-item-attention">
          {t("needs_attention")}
        </Box>
      ) : null}
      <Box className="detailed-result-item">
        <Box
          className="detailed-result-item-icon"
          style={{ borderColor: `${innerBorderColor}` }}
        >
          <img src={icon} alt={heading} />
        </Box>
        <Box className="detailed-result-item-header">
          <Box className="detailed-result-item-heading">{heading}</Box>
          <Box className="detailed-result-item-subheading">{subHeading}</Box>
        </Box>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          className="detailed-result-item-divider"
        />
        <Box className="detailed-result-item-action">
          <Box className="detailed-result-item-btn">
            <img src={dropDown} alt="drop-down" />
          </Box>
          <Box className="detailed-result-item-subheading">
            {t("see_all_words")}
          </Box>
        </Box>
      </Box>
      {open && (
        <Box className="detailed-result-item-opendropdown">
          {words.map((word, idx) => (
            <Box key={idx} className="detailed-result-item-opendropdown-word">
              {word}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default DetailedResultCard;
